
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEngineFill as ObiEngineFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-engine-fill.js';
 
 
 

 
 export const ObiEngineFill = createComponent({
   react: React,
   tagName: 'obi-engine-fill',
   elementClass: ObiEngineFillElement,
   events: {
     
   }
  });
 
 